export const getCurrentHoursAndMinutes = () => {

    let newDate = new Date();

    return {
        hours: newDate.getHours(),
        minutes: newDate.getMinutes()
    }
}